module.exports = __webpack_public_path__ + "static/media/expanding_blue.1f402f47.png";